/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_containerAlias = [
    {
        id: '',
        il_ocean_import_cntr_id: '',
        alias_name: '',
        alias_bol_number: '',
        alias_bol_link: '',
        alias_quantity: 0,
        il_opus_volume_unit_id: '',
        il_location_id_pick_up: '',
        il_location_id_deliver_to: '',
        alias_etd: null,
        alias_eta: null,
        il_trade_partner_id: '',
        alias_shipment_type: '-',
    },
];

const oimContainerAliasUpdateSlice = createSlice({
    name: 'oimContainerAliasUpdateForm',
    initialState: initialState_containerAlias,
    reducers: {
        setContainerAliasFormData: (state, action) => {
            return action.payload;
        },
        addAlias: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteAlias: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((container) => container.id !== idToDelete);
        },
        setAliasUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
    },
});

export const { setContainerAliasFormData, addAlias, deleteAlias, setAliasUpdateData } =
    oimContainerAliasUpdateSlice.actions;
export default oimContainerAliasUpdateSlice.reducer;
